export default __webpack_public_path__ + "static/media/banner8.9160e5da.jpg";